export default __webpack_public_path__ + "static/media/cqdr.1cc9789c.svg";